module.exports = __webpack_public_path__ + "static/media/unity.d6f423dc.jpg";